module.exports = __webpack_public_path__ + "static/media/angle-left-solid.e27fed28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/angle-left-solid.svg
// module id = 922
// module chunks = 58